module.exports = __webpack_public_path__ + "img/hospitality.81c89519.png";